// extracted by mini-css-extract-plugin
export var aircallIframe = "_hb-3";
export var fabContainer = "_hb-5";
export var fabRinging = "_hb-6";
export var loadingOverlay = "_hb-4";
export var pulse = "_hb-7";
export var widgetContent = "_hb-2";
export var widgetPanel = "_hb-0";
export var widgetPanelExpanded = "_hb-1";